// MS50 #2984 — Stimulus "document-type-other" controller.
//
// The /my_documents upload form has a document-type <select> whose options each
// carry a data-slug. When the selected type is the "Other" catch-all
// (data-slug="other"), reveal a freeform "custom label" text field so the
// uploader can describe the document; that label is posted as
// params[:custom_label] and persisted into document_metadata.metadata. For any
// other type the field is hidden and its value cleared, so a stale label can't
// leak onto a non-Other upload.
//
// connect() runs on initial load AND after every Turbo render, so the initial
// visibility always reflects the currently-selected option.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "customLabel", "customLabelGroup", "fileInput", "resumeGuidance"]

  static generalDocumentAccept = ".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg"
  static resumeAccept = ".pdf,.docx"

  connect() {
    this.toggle()
  }

  // change-> handler on the <select>, plus the initial connect() call.
  toggle() {
    if (this.selectedSlug === "other") {
      this.show()
    } else {
      this.hide()
    }

    this.updateAcceptedFormats()
  }

  show() {
    if (this.hasCustomLabelGroupTarget) {
      this.customLabelGroupTarget.classList.remove("d-none")
    }
  }

  hide() {
    if (this.hasCustomLabelGroupTarget) {
      this.customLabelGroupTarget.classList.add("d-none")
    }
    if (this.hasCustomLabelTarget) {
      this.customLabelTarget.value = ""
    }
  }

  updateAcceptedFormats() {
    if (!this.hasFileInputTarget) {
      return
    }

    const resumeSelected = this.selectedSlug === "resume"
    this.fileInputTarget.accept = resumeSelected ? this.constructor.resumeAccept : this.constructor.generalDocumentAccept
    if (this.hasResumeGuidanceTarget) {
      this.resumeGuidanceTarget.classList.toggle("d-none", !resumeSelected)
    }
  }

  // data-slug of the currently-selected <option>, or null if none/blank.
  get selectedSlug() {
    if (!this.hasSelectTarget) {
      return null
    }
    const select = this.selectTarget
    const option = select.options[select.selectedIndex]
    return option ? option.dataset.slug : null
  }
}
